<template>
  <div class="loading-spinner" :class="[loaderClass, variant, 'size-' + size, { bordered: border, 'button-spinner': buttonSpinner }]">
    <svg class="gk-spinner" viewBox="0 0 50 50">
      <circle class="path" cx="25" cy="25" r="15" fill="none" stroke-width="2"></circle>
    </svg>
    <div v-if="displayText" class="gk-spinner-title">{{ displayText }}</div>
  </div>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    border: {
      type: Boolean,
      default: false
    },
    displayText: {
      type: String,
      defailt: null
    },
    minHeight: {
      type: Boolean,
      default: false
    },
    buttonSpinner: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: 'lg'
    }
  },
  computed: {
    loaderClass () {
      return [
        (this.minHeight) ? 'loading-spinner--min-height' : '',
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
  .loading-spinner {
    transition: opacity 0.3s ease;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255,255,255,0.8);
    z-index: 100;
    border-radius: inherit;
    &.bordered {
      border: 1px solid $colorBorderDash;
    }
    &.solid {
      background: rgba(255,255,255,1);
    }
    &--min-height {
      min-height: 360px;
    }

    &.button-spinner {
      background: none;
      &.primary {
        background: $colorBrand;
        .gk-spinner {
          .path {
            stroke: white;
          }
        }
      }
      &.accountants {
        background: $colorAccountants;
        .gk-spinner {
          .path {
            stroke: white;
          }
        }
      }
    }
    &.button-spinner, &.size-sm {
      .gk-spinner {
        margin: -18px 0 0 -18px;
        width: 36px;
        height: 36px;
      }
    }
  } 
  .gk-spinner {
    animation: rotate 2s linear infinite;
    z-index: 2;
    position: absolute;
    top: 50%;
    left: 50%;
    margin: -25px 0 0 -25px;
    width: 50px;
    height: 50px;
    
    .path {
      stroke: $colorBrand;
      stroke-linecap: round;
      animation: dash 1.5s ease-in-out infinite;
    }
  }
  .gk-spinner-title {
    z-index: 2;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, 40px);
  }
  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }
</style>